import {useSelector} from "react-redux";
import {useCookies} from "react-cookie";
import jwt_decode from "jwt-decode";
import {Button, TextField} from "@mui/material";
import {useState} from "react";
import {updatePassword} from "./actions/auth";
import roles from "./utilities/roles";
import {passwordProblem, MIN_PASSWORD_LENGTH} from "./utilities/permissions";

const Profile = () => {
    const auth = useSelector(state => state.auth.value );
    //const [cookies, setCookie, removeCookie] = useCookies(['access_token']);
    const [cookies] = useCookies(['access_token']);
    // P1-20 / M-2: the server now requires the current password before it will set a
    // new one. Before this, an authenticated request could set any password with no
    // proof of identity, so a stolen token was a permanent account takeover.
    const [ currentPassword, setCurrentPassword ] = useState('');
    const [ newPassword, setNewPassword ] = useState('');
    const [ newPasswordConfirmation, setNewPasswordConfirmation ] = useState('');
    const [ updatingPassword, setUpdatingPassword ] = useState(false);
    const [ showPasswordUpdated, setShowPasswordUpdated ] = useState(false);
    const [ failureMessage, setFailureMessage ] = useState('');
    const decoded = jwt_decode(cookies.access_token);

    // The same length rule the server applies, so the refusal is shown before a
    // round trip rather than after one. The server still enforces it -- this only
    // decides whether the button is worth pressing.
    const localProblem = passwordProblem(newPassword);
    const passwordsMatch = newPassword === newPasswordConfirmation;
    const canSubmit = currentPassword.length > 0 && localProblem === null && passwordsMatch;

    const processPwUpdate = async () => {
        setUpdatingPassword(true);
        const result = await updatePassword(auth.token, currentPassword, newPassword);
        if( result?.status === "success" ) {
            setShowPasswordUpdated(true);
            setFailureMessage('');
            setCurrentPassword('');
            setNewPassword('');
            setNewPasswordConfirmation('');
        } else {
            setShowPasswordUpdated(false);
            // Say what actually went wrong. "Failed to update password" was the only
            // message this page could produce, which is unhelpful now that there are
            // two distinct refusals (wrong current password, new one too short).
            setFailureMessage(result?.message || 'Failed to update password');
        }
        setUpdatingPassword(false);
    };

    return (
        <div style={{display: "flex", flexDirection: "column"}}>
            <h1>Profile</h1>
            <TextField style={{marginLeft: 10, marginTop: 10, width: 200}} id="username" label="Username" variant="outlined" value={decoded.user.username} disabled={true}/>
            <TextField style={{marginLeft: 10, marginTop: 10, width: 200}} id="username" label="Role" variant="outlined" value={roles[decoded.user.role]} disabled={true}/>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: !passwordsMatch ? undefined : "none", backgroundColor: "#FFDDDD", color: "red" , textAlign: "center"}}>Passwords do not match</div>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: newPassword.length > 0 && localProblem !== null ? undefined : "none", backgroundColor: "#FFDDDD", color: "red" , textAlign: "center"}}>Must be at least {MIN_PASSWORD_LENGTH} characters</div>
            <TextField type="password" onChange={(e) => setCurrentPassword(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 200}} id="current-password" label="Current Password" variant="outlined" value={currentPassword} />
            <TextField type="password" onChange={(e) => setNewPassword(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 200}} id="new-password" label="New Password" variant="outlined" value={newPassword} />
            <TextField type="password" onChange={(e) => setNewPasswordConfirmation(e.target.value)} style={{marginLeft: 10, marginTop: 10, width: 200}} id="new-password-confirmation" label="Confirm New Password" variant="outlined" value={newPasswordConfirmation} />
            <Button style={{margin: 10, width: 200}} variant="contained" color="primary" disabled={!canSubmit} onClick={processPwUpdate}>Update Password</Button>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: failureMessage !== '' ? undefined : "none", backgroundColor: "#FFDDDD", color: "red" , textAlign: "center"}}>{failureMessage}</div>
            <div style={{ margin: 10, padding: 5, borderRadius: 4, width: 200, display: showPasswordUpdated ? undefined : "none", backgroundColor: "#006225", color: "white", textAlign: "center" }}>Password updated.</div>
            {updatingPassword ? (
                <div style={{position: "fixed", top:0, bottom: 0, left: 0, right:0, backgroundColor: "#00000022", display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div className="lds-roller">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            ) : null}
        </div>
    )
}

export default Profile;